import "./cover.css";
// import Batumi from '../Assets/batumi12.png';
import { Carousel } from 'react-carousel-minimal';
import CodeSlide from '../Assets/codeslide1.png';
import Dev from '../Assets/dev1.jpg';
import Code1 from '../Assets/code1.jpg';
import Code2 from '../Assets/code2.jpg';
import Code3 from '../Assets/code3.jpg';
import Office1 from '../Assets/office1.jpg';
import Code6 from '../Assets/code6.jpg';
import { red } from "@mui/material/colors";
export default function Cover() {
    
    const data = [
        {
        //   image: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/GoldenGateBridge-001.jpg/1200px-GoldenGateBridge-001.jpg",
          image: CodeSlide,

          caption: `<p>უმაღლესი ხარისხი</p>`
        },
        {
          image: Dev,
          caption: `<p>ჭკვიანური გადაწყვეტილებები</p>`
        },
        {
          image: Code1,
          caption: ` <p>უსწრაფესი გზა მიზნის მისაღწევად</p>`
        },
        {
            image: Code2,
              caption: `<p>თანამედროვე ტექნოლოგიები</p>`
        },
        {
          image: Code3,
              caption: `<p>სწრაფი პროდაქშენი</p>`
        },
        // {
        //   image: Office1,
        // //   caption: "Darjeeling"
        // },
        {
          image: Code6,
          caption: `<p>საუკეთესო სერვისი</p>`
        },
        // {
        //   image: "https://images.ctfassets.net/bth3mlrehms2/6Ypj2Qd3m3jQk6ygmpsNAM/61d2f8cb9f939beed918971b9bc59bcd/Scotland.jpg?w=750&h=422&fl=progressive&q=50&fm=jpg",
        // //   caption: "Scotland"
        // },
        // {
        //   image: "https://www.oyorooms.com/travel-guide/wp-content/uploads/2019/02/summer-7.jpg",
        // //   caption: "Darjeeling"
        // }
      ];
    
      const captionStyle = {
        fontSize: '2em',
        fontWeight: 'bold',
        backgroundColor: 'rgba(0,0,0,0.7)',
        width: '50%',
        marginLeft: '25%',
        padding: '0.5em',
        borderRadius: '0.8em',
      }
    //   const slideNumberStyle = {
    //     fontSize: '20px',
    //     fontWeight: 'bold',
    //   }
    
    return (
        <div>
            {/* <img className='img-batumi' src={Batumi}/> */}
            <div style={{ textAlign: "center" }}>
        <div style={{
        //   padding: "0 20px"
        }}>
          <Carousel
            data={data}
            time={3000}
            width="100%"
            height="600px"
            captionStyle={captionStyle}
            // radius="10px"
            // slideNumber={true}
            // slideNumberStyle={slideNumberStyle}
            captionPosition="top"
            automatic={true}
            dots={true}
            pauseIconColor="white"
            pauseIconSize="40px"
            slideBackgroundColor="black"
            slideImageFit="cover"
            // thumbnails={true}
            // thumbnailWidth="100px"
            style={{
             textAlign: "center",
            //   maxWidth: "850px",
            //   maxHeight: "500px",
            //   margin: "auto",
            }}
          />
        </div>
        <h2>GEMINI IMPULSE SOLUTIONS</h2>
        <p>უსწრაფესი გზა მიზნის მისაღწევად</p>
      </div>
        </div>
    )
}